import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatDividerModule } from '@angular/material/divider';
import { MatRadioModule } from '@angular/material/radio';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { BreadcrumbModule, TableModule, EmptyStateModule } from '@michelin/theme';
import { SharedModule } from '../../shared/shared.module';
import { InventoryComponent } from './components/inventory/inventory.component';
import { StockMovementHistoryComponent } from './components/stock-movement-history/stock-movement-history.component';
import { StockManagementComponent } from './components/stock-management/stock-management.component';

@NgModule({
  declarations: [InventoryComponent, StockMovementHistoryComponent, StockManagementComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatTabsModule,
    MatExpansionModule,
    MatDividerModule,
    MatRadioModule,
    MatProgressBarModule,
    BreadcrumbModule,
    TableModule,
    EmptyStateModule,
    SharedModule
  ],
  exports: [InventoryComponent]
})
export class InventoryModule {}
